export default __webpack_public_path__ + "static/media/multi-field.c30fe524.png";